let bundleArray = [];

document.addEventListener("DOMContentLoaded", () => {
  initializeSliders();
  initializeEventListeners();
  initializeModalEventListeners();
  attachAddToCartListener();

  document.querySelectorAll(".gift-selectors--tubes .form-check-input").forEach((element) => {
    element.addEventListener("change", updateTotalPrices);
  });
});
document.addEventListener("DOMContentLoaded", () => {
  const handleScroll = () => {
    if (window.innerWidth >= 992) return;

    const cygContainer = document.querySelector(".CYG-container");
    const cygBundleSelection = document.querySelector(".cyg-bundle-selection");

    if (!cygContainer || !cygBundleSelection) return;

    const rect = cygContainer.getBoundingClientRect();
    const offset = 450; // Adjust this value as needed

    if (rect.bottom < offset || rect.top > window.innerHeight - offset) {
      cygBundleSelection.style.display = "none";
    } else {
      cygBundleSelection.style.display = "";
    }
  };

  window.addEventListener("scroll", handleScroll);
});

function initializeSliders() {
  const createGiftSlider = document.querySelector("#create-a-gift-slider");
  if (createGiftSlider) {
    new Splide("#create-a-gift-slider", {
      type: "loop",
      dots: false,
      start: 1,
      pagination: false,
      gap: 4,
      autoplay: true,
      interval: 4000,
      perPage: 1,
      focus: "center",
    }).mount();
  }
}
function initializeEventListeners() {
  const giftButton = document.querySelector("#view-assortments");
  const viewBuilderButton = document.querySelector("#view-builder");
  const backButtons = document.querySelectorAll(".step-container .step-back-btn button");
  const tubeSizeRadios = document.querySelectorAll(".gift-selectors--size .form-check-input");
  const tubeCountSelectors = document.querySelectorAll(".gift-selectors--tubes .form-check-input");
  const flavorSelectors = document.querySelectorAll(".gift-selectors--flavor .form-check-input");
  const addToBundleBottomButtons = document.querySelectorAll(".btm-add-to-bundle");
  const greetingSelect = document.getElementById("greeting-select");
  const hiddenInput = document.getElementById("selected-variant-id");
  const addToBundleButtons = document.querySelectorAll("#create-your-gift-step--CYG .btn-add-to-bundle");

  if (giftButton) {
    giftButton.addEventListener("click", handleGiftButtonClick);
  }

  if (viewBuilderButton) {
    viewBuilderButton.addEventListener("click", handleViewBuilderButtonClick);
  }

  backButtons.forEach((button) => {
    button.addEventListener("click", handleBackButtonClick);
  });

  // tubeSizeRadios.forEach(radio => {
  //     radio.addEventListener('change', handleTubeSizeChange);
  // });

  flavorSelectors.forEach((input) => {
    input.addEventListener("change", handleFlavorSelection);
  });

  tubeCountSelectors.forEach((input) => {
    input.addEventListener("click", handleTubeCountSelection);
  });

  addToBundleButtons.forEach((btn) => {
    btn.addEventListener("click", handleAddToBundleClick);
  });

  addToBundleBottomButtons.forEach((btn) => {
    btn.addEventListener("click", handleAddToBundleBottomClick);
  });

  if (greetingSelect && hiddenInput) {
    greetingSelect.addEventListener("change", () => {
      const selectedOption = greetingSelect.options[greetingSelect.selectedIndex];
      hiddenInput.value = selectedOption.getAttribute("data-variant-id");
    });
  }
}

function attachAddToCartListener() {
  const atcButtons = document.querySelectorAll(".atc-assortment-collection");
  atcButtons.forEach((button) => {
    button.addEventListener("click", handleAddToCartWithGiftBand);
  });
}

function scrollToCYGContainer() {
  const cygContainer = document.querySelector(".CYG-container");
  if (cygContainer) {
    const headerHeight = document.querySelector("#header-group").offsetHeight;
    const offset = cygContainer.getBoundingClientRect().top + window.scrollY - headerHeight; // Adjust the offset by 10 pixels
    window.scrollTo({ top: offset, behavior: "smooth" });
  }
}

function handleGiftButtonClick() {
  document.querySelector("#create-your-gift-step--landing").style.display = "none";
  document.querySelector("#create-your-gift-step--assortments").style.display = "block";
  window.scrollTo({ top: 0, behavior: "smooth" });
}

function handleViewBuilderButtonClick(e) {
  const selectedValue = e.target.closest(".new-step-boxes").querySelector('input[name="gift-count"]:checked').value;
  const cygStepElement = document.getElementById("create-your-gift-step--CYG");
  cygStepElement.setAttribute("data-selected-count", selectedValue);
  document.querySelector("#create-your-gift-step--landing").style.display = "none";
  document.querySelector("#create-your-gift-step--CYG").style.display = "block";
  scrollToCYGContainer();
}

function handleBackButtonClick(event) {
  const button = event.target;
  const stepContainer = button.closest(".step-container");
  stepContainer.style.display = "none";
  document.querySelector("#create-your-gift-step--landing").style.display = "flex";
  scrollToCYGContainer();
}

function handleTubeCountSelection(event) {
  const input = event.target;
  const selectedTubeCount = input.value; // Define selectedTubeCount based on the input value
  document
    .querySelectorAll("#create-your-gift-step--landing .gift-selectors--tubes .new-gift--radio-label")
    .forEach((card) => {
      card.classList.remove("active");
    });
  input.closest("li").classList.add("active");

  // Call the new function to filter collection items
  // filterCollectionItems(selectedTubeCount);

  // Reset prices when changing tube count
  const bundlePriceSaleElement = document.querySelector(".bundle-price--sale");
  if (bundlePriceSaleElement) {
    const basePrice = input.getAttribute("data-regular-assortment-price");
    bundlePriceSaleElement.textContent = basePrice;
  }

  document.querySelectorAll(".create-your-gift-summary-list-item").forEach((elem, index) => {
    if (index < Number(input.value)) {
      elem.removeAttribute("hidden");
    } else {
      elem.setAttribute("hidden", "hidden");
    }
  });

  // Add this new section before updateGridLayout()
  document.querySelectorAll(".btn-add-to-bundle").forEach((button) => {
    button.disabled = false;
    button.textContent = "Add";
  });

  // Reset any quantity containers back to Add buttons
  document.querySelectorAll(".quantity-container").forEach((container) => {
    const btnAdd = document.createElement("button");
    btnAdd.className = "btn-add btn-add-to-bundle btn btn-primary text-uppercase";
    btnAdd.dataset.title = container.dataset.title;
    btnAdd.dataset.variantId = container.dataset.variantId;
    btnAdd.dataset.addAnother = "Add";
    btnAdd.type = "button";
    btnAdd.textContent = "Add";
    btnAdd.addEventListener("click", handleAddToBundleClick);
    container.replaceWith(btnAdd);
  });

  const headingCountUpdateElement = document.getElementById("headingCountUpdate");
  if (headingCountUpdateElement) {
    headingCountUpdateElement.textContent = selectedTubeCount;
  }

  updateGridLayout();
  bundleArray = [];
  buildSummary();
  updateRemainingCount();
  updateTotalPrices();
}

function updateGridLayout() {
  const list = document.getElementById("create-your-gift-summary-list");
  const visibleItems = list.querySelectorAll("li:not([hidden])");
  const visibleCount = visibleItems.length;

  if (visibleCount % 4 === 0) {
    list.classList.remove("summary-grid--3");
    list.classList.add("summary-grid--4");
  } else {
    list.classList.remove("summary-grid--4");
    list.classList.add("summary-grid--3");
  }
}

function updateRemainingCount() {
  const remainingCountElement = document.getElementById("remaining-count-update");
  const boxSize = Number(document.querySelector(".gift-selectors--tubes .form-check-input:checked").value);
  const remainingCount = boxSize - bundleArray.length;
  remainingCountElement.textContent = remainingCount;
}

function handleFlavorSelection(event) {
  const selectedFlavor = event.target.value;
  fetchFilteredCollection(selectedFlavor);
}

function fetchFilteredCollection(selectedFlavor) {
  console.log("Selected flavor:", selectedFlavor);
  const products = document.querySelectorAll(".cyg-assortment-selectors .product-item");

  products.forEach((product) => {
    if (selectedFlavor === "all" || product.classList.contains(`flavor--${selectedFlavor}`)) {
      product.style.display = "block";
    } else {
      product.style.display = "none";
    }
  });
}

function handleAddToBundleClick(event) {
  const btn = event.target;
  btn.disabled = true;

  const productItem = btn.closest(".product-item");
  const imageUrl = productItem ? productItem.dataset.imageUrl : "";
  updateBundlePrice(productItem, true); // Add premium price if applicable

  bundleArray.push({
    title: btn.dataset.title,
    id: Number(btn.dataset.variantId),
    imageUrl: imageUrl,
    quantity: 1,
  });

  replaceButtonWithQuantityInput(btn, imageUrl);
  buildSummary();
  updateRemainingCount();
}

function replaceButtonWithQuantityInput(btn, imageUrl) {
  const quantityContainer = document.createElement("div");
  quantityContainer.className = "quantity-container";
  quantityContainer.dataset.variantId = btn.dataset.variantId;

  const minusButton = document.createElement("button");
  minusButton.className = "btn-minus";
  minusButton.textContent = "-";

  const quantitySpan = document.createElement("span");
  quantitySpan.className = "quantity-span tw:select-none tw:cursor-default";
  quantitySpan.textContent = "1";

  const hiddenInput = document.createElement("input");
  hiddenInput.type = "number";
  hiddenInput.className = "hidden-quantity-input";
  hiddenInput.value = 1;
  hiddenInput.style.display = "none";

  const plusButton = document.createElement("button");
  plusButton.className = "btn-plus";
  plusButton.textContent = "+";

  quantityContainer.appendChild(minusButton);
  quantityContainer.appendChild(quantitySpan);
  quantityContainer.appendChild(hiddenInput);
  quantityContainer.appendChild(plusButton);

  btn.replaceWith(quantityContainer);

  minusButton.addEventListener("click", () => {
    let currentValue = parseInt(quantitySpan.textContent);
    if (currentValue > 1) {
      currentValue--;
      quantitySpan.textContent = currentValue;
      hiddenInput.value = currentValue;
      // Get productItem relative to quantityContainer instead of btn
      const productItem = quantityContainer.closest(".product-item");
      if (productItem) {
        updateBundlePrice(productItem, false);
      }
      removeFromBundleArray(quantityContainer.dataset.variantId);
    } else {
      const btnAdd = document.createElement("button");
      btnAdd.className = "btn-add btn-add-to-bundle btn btn-primary text-uppercase";
      btnAdd.dataset.title = quantityContainer.dataset.title;
      btnAdd.dataset.variantId = quantityContainer.dataset.variantId;
      btnAdd.dataset.addAnother = "Add";
      btnAdd.type = "button";
      btnAdd.textContent = "Add";
      // Update price before replacing
      const productItem = quantityContainer.closest(".product-item");
      if (productItem) {
        updateBundlePrice(productItem, false);
      }
      quantityContainer.replaceWith(btnAdd);
      btnAdd.disabled = false;
      btnAdd.addEventListener("click", handleAddToBundleClick);
      removeFromBundleArray(quantityContainer.dataset.variantId);
    }
  });

  plusButton.addEventListener("click", () => {
    const boxSize = Number(document.querySelector(".gift-selectors--tubes .form-check-input:checked").value);
    if (bundleArray.length < boxSize) {
      let currentValue = parseInt(quantitySpan.textContent);
      currentValue++;
      quantitySpan.textContent = currentValue;
      hiddenInput.value = currentValue;
      const productItem = quantityContainer.closest(".product-item");
      if (productItem) {
        updateBundlePrice(productItem, true);
      }
      addToBundleArray(quantityContainer.dataset.title, quantityContainer.dataset.variantId, imageUrl);
    } else {
      alert("You have reached the maximum number of items for this bundle.");
    }
  });
}

function handleAddToBundleBottomClick(event) {
  const btn = event.target.closest(".btm-add-to-bundle");

  const hasGiftBand = btn.getAttribute("data-giftband-available") === "true";

  if (hasGiftBand) {
    const modal = document.querySelector("#createGiftModal");
    if (modal) {
      const modalInstance = new bootstrap.Modal(modal);
      modalInstance.show();
    }
    return;
  }

  btn.innerHTML = `
        <div class="spinner-border spinner-border-sm" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    `;

  const items = [];
  const giftBoxSize = document.querySelector('input[name="gift-count"]:checked').value;
  const uuid = crypto.randomUUID();
  const greetingSelect = document.getElementById("giftband-select");
  let selectedGreeting = "";
  let selectedGiftBandVariantId = "";

  // Check for Valentine's Day gift band first
  const valentinesDayCheckbox = document.querySelector(".valentines-day-giftband__checkbox input");
  const isValentinesDaySelected = valentinesDayCheckbox && valentinesDayCheckbox.checked;

  if (isValentinesDaySelected) {
    selectedGreeting = "Happy Valentine's Day";
    selectedGiftBandVariantId = document.querySelector(".valentines-day-giftband__checkbox input").dataset.variantId;
  } else if (greetingSelect) {
    const selectedOption = greetingSelect.options[greetingSelect.selectedIndex];
    selectedGreeting = selectedOption.getAttribute("data-giftband-title");
    selectedGiftBandVariantId = greetingSelect.value;
  }

  const giftBandCheckbox = document.getElementById("gift-band-toggle");

  // Process bundle array
  bundleArray = bundleArray.reduce((acc, curr) => {
    const index = acc.findIndex((elem) => elem.id === curr.id);
    if (index !== -1) {
      acc[index].quantity += curr.quantity;
    } else {
      acc.push({
        id: curr.id,
        quantity: curr.quantity,
        properties: {
          Box: `${giftBoxSize} Flavor Gift Box`,
          _bundleParentId: uuid,
          _bundle_id: uuid,
        },
      });
    }
    return acc;
  }, []);

  items.push(...bundleArray);

  // Create gift box properties
  const giftBoxProperties = {
    _bundleId: uuid,
    _bundle_id: uuid,
    _bundle_parent: true,
  };

  // Set greeting if either Valentine's Day or regular gift band is selected
  if ((giftBandCheckbox && giftBandCheckbox.checked && selectedGreeting) || isValentinesDaySelected) {
    giftBoxProperties["Greeting"] = selectedGreeting;
  }

  // Add gift box item
  items.push({
    id: Number(document.querySelector('input[name="gift-count"]:checked').dataset.variantId),
    qty: 1,
    properties: giftBoxProperties,
  });

  // Add gift band if selected (either Valentine's Day or regular)
  if ((giftBandCheckbox && giftBandCheckbox.checked && selectedGiftBandVariantId) || isValentinesDaySelected) {
    items.push({
      id: Number(selectedGiftBandVariantId),
      qty: 1,
      properties: {
        Box: `${giftBoxSize} Flavor Gift Box`,
        _bundleParentId: uuid,
        _bundle_id: uuid,
      },
    });
  }

  fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ items }),
  }).then((response) => {
    window.refreshCartContents(response);
    btn.innerHTML = btn.dataset.text;

    if (document.querySelector("#offcanvas-cart")) {
      bootstrap.Offcanvas.getOrCreateInstance("#offcanvas-cart").show();
    }
    closeModal();

    if (giftBandCheckbox) {
      giftBandCheckbox.checked = giftBandCheckbox.defaultChecked;
    }

    // Reset Valentine's Day checkbox if it exists
    // Refresh the Valentine's Day gift band element
    const valentinesDayElement = document.querySelector(".valentines-day-giftband");
    if (valentinesDayElement) {
      fetch(window.location.pathname)
        .then((response) => response.text())
        .then((html) => {
          const parser = new DOMParser();
          const newDoc = parser.parseFromString(html, "text/html");
          const newValentinesDayElement = newDoc.querySelector(".valentines-day-giftband");
          if (newValentinesDayElement) {
            valentinesDayElement.innerHTML = newValentinesDayElement.innerHTML;

            // Reattach the event listener
            const checkbox = valentinesDayElement.querySelector('input[type="checkbox"]');
            if (checkbox) {
              checkbox.addEventListener("change", function () {
                const text = this.parentElement.querySelector("h4");
                text.textContent = this.checked ? "REMOVE" : "ADD";
                const details = this.parentElement.parentElement.querySelector(".valentines-day-giftband__details p");
                details.textContent = this.checked
                  ? `Don't want the Valentine's Day Gift Band? Click here to remove it.`
                  : `Want a Valentine's Day Gift Band? Click here to add it.`;
              });
            }
          }
        });
    }

    // Reset bundle state
    bundleArray = [];
    buildSummary();
    updateRemainingCount();

    // Reset the bundle price to base price
    const selectedTubeCount = document.querySelector(".gift-selectors--tubes .form-check-input:checked");
    const bundlePriceSaleElement = document.querySelector(".bundle-price--sale");
    if (bundlePriceSaleElement && selectedTubeCount) {
      const basePrice = selectedTubeCount.getAttribute("data-regular-assortment-price");
      bundlePriceSaleElement.textContent = basePrice;
    }

    // Reset quantity containers
    document.querySelectorAll(".quantity-container").forEach((container) => {
      const btnAdd = document.createElement("button");
      btnAdd.className = "btn-add btn btn-primary text-uppercase";
      btnAdd.dataset.title = container.dataset.title;
      btnAdd.dataset.variantId = container.dataset.variantId;
      btnAdd.type = "button";
      btnAdd.textContent = "Add";
      btnAdd.addEventListener("click", handleAddToBundleClick);

      container.replaceWith(btnAdd);
    });
  });
}

function addToBundleArray(title, variantId, imageUrl) {
  bundleArray.push({
    title: title,
    id: Number(variantId),
    imageUrl: imageUrl,
    quantity: 1,
  });
  buildSummary();
  updateRemainingCount();
}

function removeFromBundleArray(variantId) {
  for (let i = bundleArray.length - 1; i >= 0; i--) {
    if (bundleArray[i].id === Number(variantId)) {
      bundleArray.splice(i, 1);
      break;
    }
  }
  buildSummary();
  updateRemainingCount();
}

function buildSummary() {
  const summaryItems = document.querySelectorAll(".create-your-gift-summary-list-item");
  const boxSize = Number(document.querySelector(".gift-selectors--tubes .form-check-input:checked").value);

  bundleArray = bundleArray.slice(0, boxSize);

  summaryItems.forEach((elem, index) => {
    if (index < bundleArray.length) {
      const { imageUrl } = bundleArray[index];
      elem.classList.add("active");
      const imageWrapper = elem.querySelector(".img-wrapper");
      if (imageWrapper && imageUrl) {
        imageWrapper.innerHTML = `<span class="empty-text">Add</span> <img src="${imageUrl}" alt="Gift Image" class="hide">
                                          <button class="btn btn-close hide" aria-label="remove"></button>`;
      }
    } else {
      elem.classList.remove("active");
    }
  });

  // Get the add to cart button
  const addToCartBtn = document.querySelector(".btm-add-to-bundle");
  if (addToCartBtn) {
    // Enable the button only when bundle is complete
    addToCartBtn.disabled = bundleArray.length !== boxSize;
  }

  document.querySelectorAll("#create-your-gift-step--CYG .btn-add").forEach((btn) => {
    btn.disabled = bundleArray.length === boxSize;
  });

  document.querySelector(".collection").classList.toggle("has-items", bundleArray.length > 0);

  attachCloseButtonListeners();
}

function updateQuantityInput(variantId) {
  const quantityContainer = document.querySelector(
    `#create-your-gift-step--CYG .quantity-container[data-variant-id="${variantId}"]`,
  );
  if (quantityContainer) {
    const quantitySpan = quantityContainer.querySelector(".quantity-span");
    const hiddenInput = quantityContainer.querySelector(".hidden-quantity-input");
    if (quantitySpan && hiddenInput) {
      let currentValue = parseInt(quantitySpan.textContent);
      if (currentValue > 1) {
        currentValue--;
        quantitySpan.textContent = currentValue;
        hiddenInput.value = currentValue;
      } else {
        const btn = document.createElement("button");
        btn.className = "btn-add btn btn-primary text-uppercase";
        btn.dataset.title = quantityContainer.dataset.title;
        btn.dataset.variantId = variantId;
        btn.dataset.addAnother = "Add";
        btn.type = "button";
        btn.textContent = "Add";
        quantityContainer.replaceWith(btn);
        btn.disabled = false;
        btn.addEventListener("click", handleAddToBundleClick);
      }
    }
  }
}

function updateTotalPrices() {
  const selectedTubeCount = document.querySelector(".gift-selectors--tubes .form-check-input:checked");
  if (!selectedTubeCount) return;

  const priceAttribute = "data-regular-assortment-price";
  const comparePriceAttribute = "data-regular-assortment-price-compare";

  const priceElement = document.getElementById("cyg-price");
  const comparePriceElement = document.getElementById("cyg-compare-price");

  if (priceElement && comparePriceElement) {
    const price = selectedTubeCount.getAttribute(priceAttribute);
    const comparePrice = selectedTubeCount.getAttribute(comparePriceAttribute);

    priceElement.textContent = price;
    comparePriceElement.textContent = comparePrice;
  }

  // Update the .bundle-price--sale and .bundle-price--compare elements
  const bundlePriceSaleElement = document.querySelector(".bundle-price--sale");
  const bundlePriceCompareElement = document.querySelector(".bundle-price--compare");

  if (bundlePriceSaleElement && bundlePriceCompareElement) {
    const price = selectedTubeCount.getAttribute(priceAttribute);
    const comparePrice = selectedTubeCount.getAttribute(comparePriceAttribute);

    bundlePriceSaleElement.textContent = price;
    bundlePriceCompareElement.textContent = comparePrice;
  }
}

function attachCloseButtonListeners() {
  document.querySelectorAll("#create-your-gift-summary .btn-close").forEach((btn, index) => {
    btn.addEventListener("click", () => {
      const variantId = bundleArray[index].id;
      const productItem = document.querySelector(`.product-item[data-variant-id="${variantId}"]`);
      if (productItem) {
        updateBundlePrice(productItem, false); // Subtract premium price if applicable
      }

      bundleArray.splice(index, 1);
      updateQuantityInput(variantId);
      buildSummary();
      updateRemainingCount();
    });
  });
}

function isGiftBandInStock() {
  const giftBandVariant = document.getElementById("selected-variant-id");
  return giftBandVariant && giftBandVariant.getAttribute("data-in-stock") === "true";
}

function closeModal() {
  const modal = document.getElementById("createGiftModal");
  if (modal) {
    const bootstrapModal = bootstrap.Modal.getInstance(modal);
    if (bootstrapModal && typeof bootstrapModal.hide === "function") {
      bootstrapModal.hide();
    }
  }
}
// Define the function to scroll to the top
function scrollToTop() {
  window.scrollTo({ top: 0, behavior: "smooth" });
}

// Function to update the position of the back button banners
function positionBackButtonBanners() {
  const header = document.querySelector("#header-group");
  const backButtonBanner2 = document.querySelector("#sticky-header-2");
  const backButtonBanner2Mobile = document.querySelector("#sticky-header-2-mobile");
  const backButtonBanner1 = document.querySelector("#sticky-header-1");

  if (header) {
    // Get the height of the header
    const headerHeight = header.offsetHeight;

    // Set the top position of the back button banners just below the header
    if (backButtonBanner1) {
      backButtonBanner1.style.top = `${headerHeight - 1}px`;
    }
    if (backButtonBanner2) {
      backButtonBanner2.style.top = `${headerHeight - 10}px`;
    }
    if (backButtonBanner2Mobile) {
      backButtonBanner2Mobile.style.top = `${headerHeight - 10}px`;
    }
  }
}

// Initial position update
positionBackButtonBanners();

// Recalculate position on window resize and content load
window.addEventListener("resize", positionBackButtonBanners);
window.addEventListener("load", positionBackButtonBanners);

let previousFilterState = {
  tubeCount: null,
  tubeType: null,
};

// document.querySelector('#show-all-assortments').addEventListener('click', () => {
//     const collectionItems = document.querySelectorAll('.assortment-collection-card');
//     collectionItems.forEach(item => {
//         item.style.display = 'list-item';
//     });
//     scrollToTop();
// });

// document.querySelectorAll('.step-container .step-back-btn button').forEach(button => {
//     button.addEventListener('click', () => {
//         if (previousFilterState.tubeCount && previousFilterState.tubeType) {
//             filterCollectionItems(previousFilterState.tubeCount, previousFilterState.tubeType);
//         }
//     });
// });

// function filterCollectionItems(selectedTubeCount, selectedTubeType = null) {
//     if (!selectedTubeType) {
//         selectedTubeType = document.querySelector('.gift-selectors--size .form-check-input:checked').value;
//     }

//     previousFilterState.tubeCount = selectedTubeCount;
//     previousFilterState.tubeType = selectedTubeType;

//     const selectedTypeElement = document.querySelector('.gift-selectors--size .form-check-input:checked');
//     const selectedTypeValue = selectedTypeElement ? selectedTypeElement.value : null;
//     const selectedCountElement = document.querySelector(`.form-check-input[name="gift-count"][value="${selectedTubeCount}"]`);

//     const hasStock = selectedTypeValue === 'sampler' ?
//         selectedCountElement.getAttribute('sampler-in-stock') === 'true' :
//         selectedCountElement.getAttribute('regular-in-stock') === 'true';

//     const collectionItems = document.querySelectorAll('.assortment-collection-card');
//     let anyItemDisplayed = false;

//     collectionItems.forEach((item) => {
//         const filterGroupCount = item.getAttribute('data-filter-group-count');
//         const filterGroupSort = item.getAttribute('data-filter-group-type') ? item.getAttribute('data-filter-group-type').toLowerCase() : '';
//         const selectedTypeValueLower = selectedTypeValue ? selectedTypeValue.toLowerCase() : '';

//         if (filterGroupCount === selectedTubeCount &&
//             filterGroupSort === selectedTypeValueLower &&
//             hasStock) {
//             item.style.display = 'list-item';
//             anyItemDisplayed = true;
//         } else {
//             item.style.display = 'none';
//         }
//     });

//     const viewGiftBoxesButton = document.querySelector('#view-assortments');
//     if (viewGiftBoxesButton) {
//         viewGiftBoxesButton.disabled = !anyItemDisplayed || !hasStock;
//     }
// }

// document.querySelector('#show-all-assortments').addEventListener('click', () => {
//     const collectionItems = document.querySelectorAll('.assortment-collection-card');
//     collectionItems.forEach(item => {
//         item.style.display = 'list-item';
//     });
//     document.querySelector('#show-all-assortments').style.display = 'none';
//     scrollToTop();
// });

// document.querySelectorAll('.step-container .step-back-btn button').forEach(button => {
//     button.addEventListener('click', () => {
//         if (previousFilterState.tubeCount && previousFilterState.tubeType) {
//             filterCollectionItems(previousFilterState.tubeCount, previousFilterState.tubeType);
//         }
//         document.querySelector('#show-all-assortments').style.display = 'block';
//     });
// });

document.querySelector("#view-collections--everything").addEventListener("click", () => {
  // Hide the landing container
  document.querySelector("#create-your-gift-step--landing").style.display = "none";

  // Show the assortments container
  document.querySelector("#create-your-gift-step--assortments").style.display = "block";

  const collectionItems = document.querySelectorAll(".assortment-collection-card");
  collectionItems.forEach((item) => {
    item.style.display = "list-item";
  });
  scrollToTop();
});

function updateBundlePrice(productItem, isAdding = true) {
  const premiumPriceElement = productItem.querySelector(".premium-flavor-price");
  const premiumPrice = premiumPriceElement ? Number(premiumPriceElement.dataset.premiumPrice) : 0;

  const bundlePriceSaleElement = document.querySelector(".bundle-price--sale");
  if (bundlePriceSaleElement) {
    const currentPrice = parseFloat(bundlePriceSaleElement.textContent.replace("$", "")) * 100;
    const newPrice = isAdding ? currentPrice + premiumPrice : currentPrice - premiumPrice;
    bundlePriceSaleElement.textContent = `$${(newPrice / 100).toFixed(2).replace(/\.00$/, "")}`;
  }
}
